(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('IntegracaoParceiroController', IntegracaoParceiroController);

    IntegracaoParceiroController.$inject = [
        'IntegracaoParceiro',
        'Cliente',
        'Sistema',
        'Modulo',
        'SubModulo',
        'User',
        'Alerta',
        'AlertService'
    ];

    function IntegracaoParceiroController(
        IntegracaoParceiro,
        Cliente,
        Sistema,
        Modulo,
        SubModulo,
        User,
        Alerta,
        AlertService
    ) {
        var vm = this;

        vm.parceiros = [];
        vm.clientes = [];
        vm.sistemas = [];
        vm.modulos = [];
        vm.subModulos = [];
        vm.usuarios = [];
        vm.loading = true;
        vm.saving = false;

        vm.tiposChamado = ['SUPORTE', 'BUG', 'MELHORIA', 'NOVA_FUNCIONALIDADE', 'ATA'];
        vm.severidades = ['SEVERIDADE_0', 'SEVERIDADE_1', 'SEVERIDADE_2', 'SEVERIDADE_3', 'SEM_SEVERIDADE'];

        vm.load = load;
        vm.save = save;
        vm.edit = edit;
        vm.remove = remove;
        vm.resetForm = resetForm;
        vm.onModuloChange = onModuloChange;
        vm.subModulosDoModulo = subModulosDoModulo;

        resetForm();
        loadLookups();
        load();

        function emptyForm() {
            return {
                id: null,
                codigo: '',
                nome: '',
                ativo: true,
                webhookUrl: '',
                webhookToken: '',
                webhookTokenMasked: null,
                clienteId: null,
                sistemaId: null,
                moduloId: null,
                subModuloId: null,
                solicitanteId: null,
                tipoChamado: null,
                severidade: null
            };
        }

        function resetForm() {
            vm.form = emptyForm();
        }

        function loadLookups() {
            Cliente.query(function (result) {
                vm.clientes = result;
            });
            Sistema.query(function (result) {
                vm.sistemas = result;
            });
            Modulo.query(function (result) {
                vm.modulos = result;
            });
            SubModulo.query({page: 0, size: 200}, function (result) {
                vm.subModulos = result;
            });
            User.getAllInternos({}, function (result) {
                vm.usuarios = result;
            });
        }

        function load() {
            vm.loading = true;
            IntegracaoParceiro.query().then(function (response) {
                vm.parceiros = response.data;
            }, function (error) {
                AlertService.error(error.data && error.data.message ? error.data.message : 'error.http.' + error.status);
            }).finally(function () {
                vm.loading = false;
            });
        }

        function edit(p) {
            vm.form = {
                id: p.id,
                codigo: p.codigo,
                nome: p.nome,
                ativo: p.ativo !== false,
                webhookUrl: p.webhookUrl || '',
                webhookToken: '',
                webhookTokenMasked: p.webhookToken,
                clienteId: p.clienteId,
                sistemaId: p.sistemaId,
                moduloId: p.moduloId,
                subModuloId: p.subModuloId,
                solicitanteId: p.solicitanteId,
                tipoChamado: p.tipoChamado,
                severidade: p.severidade
            };
        }

        function buildPayload() {
            var payload = {
                codigo: vm.form.codigo,
                nome: vm.form.nome,
                ativo: vm.form.ativo,
                webhookUrl: vm.form.webhookUrl,
                clienteId: vm.form.clienteId,
                sistemaId: vm.form.sistemaId,
                moduloId: vm.form.moduloId,
                subModuloId: vm.form.subModuloId,
                solicitanteId: vm.form.solicitanteId,
                tipoChamado: vm.form.tipoChamado,
                severidade: vm.form.severidade
            };
            if (vm.form.webhookToken) {
                payload.webhookToken = vm.form.webhookToken;
            }
            return payload;
        }

        function subModulosDoModulo() {
            if (!vm.form.moduloId) {
                return [];
            }
            return (vm.subModulos || []).filter(function (sm) {
                return sm.modulo && sm.modulo.id === vm.form.moduloId;
            });
        }

        function onModuloChange() {
            var ids = subModulosDoModulo().map(function (sm) { return sm.id; });
            if (ids.indexOf(vm.form.subModuloId) === -1) {
                vm.form.subModuloId = null;
            }
        }

        function save() {
            if (!vm.form.id && !vm.form.webhookToken) {
                Alerta.error('Atenção', 'O token do webhook é obrigatório na criação.');
                return;
            }

            vm.saving = true;
            var request;
            if (vm.form.id) {
                request = IntegracaoParceiro.update(vm.form.id, buildPayload());
            } else {
                request = IntegracaoParceiro.create(buildPayload());
            }

            request.then(function () {
                Alerta.success('Operação realizada', 'Integração de parceiro salva com sucesso.');
                resetForm();
                load();
            }, function (error) {
                AlertService.error(error.data && error.data.message ? error.data.message : 'error.http.' + error.status);
            }).finally(function () {
                vm.saving = false;
            });
        }

        function remove(p) {
            Alerta.confirm('Atenção', 'Tem certeza que deseja remover a integração "' + p.nome + '"?', 'warning', function () {
                IntegracaoParceiro.remove(p.id).then(function () {
                    Alerta.success('Operação realizada', 'Integração de parceiro removida.');
                    if (vm.form.id === p.id) {
                        resetForm();
                    }
                    load();
                }, function (error) {
                    AlertService.error(error.data && error.data.message ? error.data.message : 'error.http.' + error.status);
                });
            }, angular.noop);
        }
    }
})();
